module.exports = __webpack_public_path__ + "img/3.2d4cbd88.svg";